export default __webpack_public_path__ + "static/media/varvara.f2ea8caa.webp";